import { ReactElement } from 'react';

import { Typography } from '@mui/material';

export const convertFirmwareNamesToReactElement = (
  firmwareNames: string[]
): ReactElement | string => {
  const firmwareName = firmwareNames.slice(0, 1).toString();

  return (
    <Typography
      sx={{ whiteSpace: 'normal', display: 'inline-block' }}
      component="span"
    >
      {firmwareNames.length > 1 ? (
        <span>
          {firmwareName}
          <Typography
            component="span"
            sx={{
              color: theme => theme.palette.black.main,
              display: 'inline-block',
              marginLeft: '4px',
            }}
          >
            (+{firmwareNames.slice(1).length} more)
          </Typography>
        </span>
      ) : (
        firmwareName
      )}
    </Typography>
  );
};
